export default __webpack_public_path__ + "static/media/_DSC0798.8db425a1.JPG";